import {
  isRomanticStyle,
  toneVariant,
  useCompanionNoun,
} from '@/utils/personalization'
import MultipleChoiceQuestionPage from '@app-studio-web/ui/pages/MultipleChoiceQuestionPage'
import type { AnswerType } from '@app-studio-web/ui/types'

const baseAnswers: AnswerType[] = [
  { emoji: '❤️', title: 'pages.onboarding.topics.love', value: 'love' },
  { emoji: '💡', title: 'pages.onboarding.topics.advice', value: 'advice' },
  { emoji: '💪', title: 'pages.onboarding.topics.health', value: 'health' },
  { emoji: '💰', title: 'pages.onboarding.topics.career', value: 'career' },
  {
    emoji: '🧘',
    title: 'pages.onboarding.topics.mindfulness',
    value: 'mindfulness',
  },
  { emoji: '✈️', title: 'pages.onboarding.topics.travel', value: 'travel' },
  {
    emoji: '🗣️',
    title: 'pages.onboarding.topics.languages',
    value: 'languages',
  },
  { emoji: '😂', title: 'pages.onboarding.topics.humor', value: 'humor' },
]

const romanticAnswers: AnswerType[] = [
  {
    emoji: '🌙',
    title: 'pages.onboarding.topics.latenight',
    value: 'latenight',
  },
  {
    emoji: '😏',
    title: 'pages.onboarding.topics.flirting',
    value: 'flirting',
  },
  { emoji: '🔮', title: 'pages.onboarding.topics.future', value: 'future' },
  { emoji: '❤️', title: 'pages.onboarding.topics.love', value: 'love' },
  {
    emoji: '🎬',
    title: 'pages.onboarding.topics.entertainment',
    value: 'entertainment',
  },
  { emoji: '✈️', title: 'pages.onboarding.topics.travel', value: 'travel' },
  { emoji: '😂', title: 'pages.onboarding.topics.humor', value: 'humor' },
  { emoji: '💪', title: 'pages.onboarding.topics.health', value: 'health' },
]

export default function TopicsQuestionPage() {
  const noun = useCompanionNoun()
  const answers = isRomanticStyle() ? romanticAnswers : baseAnswers

  return (
    <MultipleChoiceQuestionPage
      answers={answers}
      title={toneVariant('pages.onboarding.topics.title')}
      subtitle={toneVariant('pages.onboarding.topics.subtitle')}
      translationInterpolation={{ noun }}
    />
  )
}
